<!--suppress ALL -->
<template>
  <v-date-picker :value="value" :formats="formats"
                 v-bind="$attrs" class="control" @input="onInput"
                 :is-range="$attrs.mode === 'range' || $attrs['is-range']">
    <template slot-scope='{ inputValue, inputEvents }'>
      <g-input v-on="inputEvents"
               @focus="onFocusInput" @blur="onBlurInput"
               :value="(!isFocused || !inputValue) ? displayValue : inputValue" :placeholder="placeholder"
               :type="type" :size="size" :shape="shape" :disabled="disabledDatePicker">
      </g-input>
    </template>
  </v-date-picker>
</template>
<script lang="ts">
import { Component, Prop, Watch } from "annotation";
import moment from "moment";
import FormPropMixins from "../../util/mixin/FormProperties";

@Component
export default class InputDatepicker extends FormPropMixins {

  @Prop({ default: null })
  public value: any;

  @Prop({ default: "", type: String })
  public placeholder: string;

  @Prop({ default: false, type: Boolean })
  public disabledDatePicker: boolean;

  public get selected(): any {
    return this.value;
  }

  public isFocused: boolean = false;

  public onFocusInput() {
    this.isFocused = true;
  }

  public onBlurInput() {
    this.isFocused = false;
  }

  public formats: any = { input: "DD/MM/YYYY" };

  @Watch("value", { immediate: true })
  public onValueChange(val: any) {
    if (val) {
      this.$emit("change-date");
    }
  }

  public onInput(param: any) {
    const isRange = (this as any).$attrs.mode === "range" || (this as any).$attrs["is-range"];
    const isEmpty = !param || (isRange && (!param.start || !param.end));
    
    if (isEmpty && this.value && !this.isFocused) {
      // Ignore accidental null/empty emission from v-calendar on mount/background
      return;
    }
    this.$emit("input", param);
  }

  public get displayValue() {
    if (!this.selected) return "";
    try {
      if (this.selected.start && this.selected.end) {
        const start = moment(this.selected.start).format(this.formats.input);
        const end = moment(this.selected.end).format(this.formats.input);
        if (start === "Invalid date" || end === "Invalid date") return "";
        return `${start} - ${end}`;
      }
      const val = moment(this.selected).format(this.formats.input);
      return val === "Invalid date" ? "" : val;
    } catch (e) {
      return "";
    }
  }
}
</script>
